import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../core/form/Button';
import { browserHistory } from 'react-router';
import Separator from '../../../../core/layout/Separator';
import Card from '../../../../core/layout/Card';

const CertificationTestItemHistoryDetail = (props) => (
  <Card
    title="Item details"
    loading={props.fetching}
    actions={<Button icon="arrow-left" label="Back" onClick={() => browserHistory.goBack()} />}
  >
    <div>
      <b>Course</b>: <span>{props.certificationTestItem.certificationTestCourseAbility.course.name}</span>
    </div>
    <Separator size="sm" />
    <div>
      <b>Ability</b>: <span>{props.certificationTestItem.certificationTestCourseAbility.ability}</span>
    </div>
    <Separator size="sm" />
    <div>
      <b>Grammar</b>: <span>{props.certificationTestItem.item.grammar.name}</span>
    </div>
    <Separator size="sm" />
    <div>
      <b>Text</b>: <span>{props.certificationTestItem.item.text}</span>
    </div>
  </Card>
);

CertificationTestItemHistoryDetail.propTypes = {
  fetching: PropTypes.bool,
  certificationTestItem: PropTypes.shape({
    certificationTestCourseAbility: PropTypes.shape({
      ability: PropTypes.string.isRequired,
      course: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    item: PropTypes.shape({
      text: PropTypes.string.isRequired,
      grammar: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

CertificationTestItemHistoryDetail.defaultProps = {
  fetching: false,
};

export default CertificationTestItemHistoryDetail;
